import { Box, Button, Flex, Text } from '@chakra-ui/react';
import VariantItem from './VariantItem';
import {
  Control,
  FieldErrors,
  UseFieldArrayAppend,
  UseFieldArrayRemove,
  UseFieldArrayUpdate,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form';
import { type FormData } from '@/services/addProduct/types';
import { IProductEditResponse } from '@/services/manageProduct/types';

interface VariantDetailsSectionProps {
  control: Control<FormData>;
  errors: FieldErrors<FormData>;
  fields: FormData['variants'];
  append: UseFieldArrayAppend<FormData, 'variants'>;
  remove: UseFieldArrayRemove;
  update: UseFieldArrayUpdate<FormData>;
  watch: UseFormWatch<FormData>;
  product?: IProductEditResponse;
  setValue: UseFormSetValue<FormData>;
  vendorCurrency?: string;
  id?: string;
  showToast: (type: 'success' | 'error', message: string) => void;
}

const VariantDetailsSection = ({
  control,
  errors,
  fields,
  append,
  remove,
  update,
  watch,
  product,
  setValue,
  id,
  showToast,
  vendorCurrency,
}: VariantDetailsSectionProps) => {
  const addVariant = () => {
    append({
      color: { name: '', hex_code: '' },
      isAvailable: false,
      productImage: [],
      sizes: Array(1).fill({
        id: 0,
        size: '',
        variantPrice: 0,
        stockQuantity: 0,
        weight: '0.00',
        isPrimary: false,
      }),
    });
  };

  return (
    <Box
      border={'1px solid'}
      borderColor={'border.default60'}
      bg={'background.secondary'}
      borderRadius={'lg'}
    >
      <Flex p={4} direction="column" gap={4}>
        <Flex direction="row" justifyContent="space-between">
          <Text fontSize={'md'} fontWeight={'semibold'}>
            Variant details
          </Text>
        </Flex>

        {fields.map((item, index) => (
          <VariantItem
            key={index}
            control={control}
            errors={errors}
            item={item}
            index={index}
            remove={remove}
            update={update}
            watch={watch}
            product={product}
            setValue={setValue}
            id={id}
            showToast={showToast}
            totalVariants={fields.length}
            isPrimaryVariant={index === 0}
            vendorCurrency={vendorCurrency}
          />
        ))}

        <Button
          border={'none'}
          onClick={addVariant}
          w={'fit-content'}
          color="brand.primary.DEFAULT"
          textDecor={'underline'}
        >
          + Add new variant
        </Button>
      </Flex>
    </Box>
  );
};

export default VariantDetailsSection;
